import dayjs from 'dayjs'
import type { IPrescription } from './prescriptions.types'

export const prescriptionsTableColumns = (onDrugClick?: (prescription: IPrescription) => void) => [
  {
    title: 'Drug',
    dataIndex: 'drug',
    key: 'drug',
    width: 180,
    render: (drug: string, record: IPrescription) => (
      <span
        className='customLink'
        style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
        onClick={() => onDrugClick?.(record)}>
        {drug}
      </span>
    ),
    sorter: {
      compare: (a: IPrescription, b: IPrescription) => {
        return a.drug.localeCompare(b.drug)
      },
      multiple: 1,
    },
  },
  {
    title: 'Details',
    dataIndex: 'details',
    key: 'details',
    render: (details: string) => (
      <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{details}</span>
    ),
    sorter: {
      compare: (a: IPrescription, b: IPrescription) => {
        return a.details.localeCompare(b.details)
      },
      multiple: 2,
    },
  },
  {
    title: 'Qty',
    dataIndex: 'qty',
    key: 'qty',
    sorter: {
      compare: (a: IPrescription, b: IPrescription) => {
        return a.qty - b.qty
      },
      multiple: 3,
    },
  },
  {
    title: 'Refills',
    dataIndex: 'refills',
    key: 'refills',
    sorter: {
      compare: (a: IPrescription, b: IPrescription) => {
        return a.refills - b.refills
      },
      multiple: 4,
    },
  },
  {
    title: 'Filled',
    dataIndex: 'filled',
    key: 'filled',
    render: (filled: string) => {
      if (!filled) return 'N/A'
      const date = dayjs(filled)
      if (date.isValid()) {
        return date.format("ddd, MMM DD 'YY, h:mmA")
      }
      return 'N/A'
    },
    sorter: {
      compare: (a: IPrescription, b: IPrescription) => {
        return dayjs(a.filled).valueOf() - dayjs(b.filled).valueOf()
      },
      multiple: 5,
    },
  },
]
